import React from 'react';

import { Typography } from '../Typography';
import styles from './Toggle.module.scss';

interface ToggleProps {
	isToggled: boolean;
	onToggle: () => void;
}

const Toggle = ({ isToggled, onToggle }: ToggleProps) => {
	return (
		<label className={styles.toggle}>
			<input type='checkbox' checked={isToggled} onChange={onToggle} />
			<span className={styles.slider}>
				<Typography
					variant='caption3'
					color={isToggled ? 'lightblue-20' : 'white'}
					fontWeight={500}
					className={styles.sliderStatus}
				>
					OFF
				</Typography>
				<Typography
					variant='caption3'
					color={isToggled ? 'white' : 'lightblue-20'}
					fontWeight={500}
					className={styles.sliderStatus}
				>
					ON
				</Typography>
			</span>
		</label>
	);
};

export default Toggle;
